export default __webpack_public_path__ + "static/media/flag-football.e8bff558.svg";